function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';

/**
 * Minimal dual-handle range slider built from two overlapping native
 * <input type="range"> elements. No external slider dependency required.
 *
 * value: [min, max]
 * onChange: (nextValue: [min, max]) => void
 */
var DualRangeSlider = function DualRangeSlider(_ref) {
  var min = _ref.min,
    max = _ref.max,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    value = _ref.value,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var _value = _slicedToArray(value, 2),
    minValue = _value[0],
    maxValue = _value[1];
  var handleMinChange = function handleMinChange(event) {
    var next = Math.min(Number(event.target.value), maxValue - step);
    onChange([next, maxValue]);
  };
  var handleMaxChange = function handleMaxChange(event) {
    var next = Math.max(Number(event.target.value), minValue + step);
    onChange([minValue, next]);
  };
  var toPercent = function toPercent(val) {
    return (val - min) / (max - min) * 100;
  };
  var minPercent = toPercent(minValue);
  var maxPercent = toPercent(maxValue);
  return /*#__PURE__*/React.createElement("div", {
    className: "dual-range-slider ".concat(disabled ? 'dual-range-slider--disabled' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "dual-range-slider__track"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dual-range-slider__range",
    style: {
      left: "".concat(minPercent, "%"),
      width: "".concat(maxPercent - minPercent, "%")
    }
  })), /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "dual-range-slider__input dual-range-slider__input--min",
    min: min,
    max: max,
    step: step,
    value: minValue,
    disabled: disabled,
    onChange: handleMinChange,
    "aria-label": "Minimum word count"
  }), /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "dual-range-slider__input dual-range-slider__input--max",
    min: min,
    max: max,
    step: step,
    value: maxValue,
    disabled: disabled,
    onChange: handleMaxChange,
    "aria-label": "Maximum word count"
  }));
};
export default DualRangeSlider;